import { _basePath } from "config";
import React, { useCallback, useEffect } from "react";
import { Text, Button, Flex } from "@chakra-ui/react";
import { DateTime } from "luxon";
import { Redirect } from "react-router-dom";
import { useIdleTimerContext } from "react-idle-timer";
import { Trans } from "react-i18next";
import MotionDiv from "../../common/MotionDiv";
import { UserContext } from "../../context";

const Fantastic = () => {
  const idleTimer = useIdleTimerContext();
  const { userData, setUserData } = React.useContext(UserContext);
  const schedule = userData.lock.resources.filter(
    (r) => r.subCategory === "Events"
  );
  const onDone = useCallback(() => {
    setUserData({
      user: null,
      loggedIn: false,
    });
  }, [setUserData]);

  useEffect(() => {
    const restTimer = setTimeout(() => {
      onDone();
    }, 10000);
    return () => {
      clearTimeout(restTimer);
    };
  }, [idleTimer, onDone]);

  if (!userData.loggedIn) {
    return <Redirect to={_basePath} />;
  }
  return (
    <Flex
      flex={1}
      justifyContent={"center"}
      alignItems={"center"}
      direction={"column"}
      mx={[10, 15, 20]}
      my={0}
      h={"full"}
    >
      <Flex flex={1} direction={"column"} justifyContent={"center"}>
        <MotionDiv
          fontSize={"6xl"}
          textAlign={"center"}
          fontWeight={"bold"}
          color={"brand.secondary.500"}
          mb={10}
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0 }}
          transition={{
            type: "bounce",
            duration: 0.5,
          }}
        >
          <Trans i18nKey={"fantastic"}>Fantastic!</Trans>
        </MotionDiv>

        <MotionDiv
          textAlign={"center"}
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0 }}
          transition={{
            delay: 0.4,
            type: "easeInAndOut",
            duration: 0.5,
          }}
        >
          <Text fontSize={{ base: "2xl", lg: "3xl" }}>
            <Trans i18nKey={"your_appointment_for_time"}>
              Your appointment for
            </Trans>
          </Text>
          <Text
            color={"brand.secondary.500"}
            fontWeight={"bold"}
            fontSize={{ base: "4xl", lg: "4xl" }}
          >
            <Trans i18nKey={`Events.${schedule[0]?.name}`} ns={"Events"}>
              {schedule[0]?.name}
            </Trans>
          </Text>
          <Text fontSize={{ base: "2xl", lg: "3xl" }}>@</Text>
          <Text className="font-bold" fontSize={{ base: "2xl", lg: "3xl" }}>
            {DateTime.fromISO(userData?.lock?.startTime).toFormat("t")}
          </Text>
          <Text fontSize={{ base: "2xl", lg: "3xl" }}>
            <Trans i18nKey={"appointment_has_been_confirmed"}>
              has been confirmed.
            </Trans>
          </Text>
          <Text textAlign={"center"}>
            <Trans i18nKey={"please_see_staff"}>
              Please see a staff member at the time of your appointment.
            </Trans>
          </Text>
        </MotionDiv>
      </Flex>

      <MotionDiv
        display={"flex"}
        flex={0}
        direction={"column"}
        alignItems={"center"}
        justifyContent={"center"}
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0 }}
        transition={{
          delay: 0.6,
          type: "easeInAndOut",
          duration: 0.5,
        }}
      >
        <Button
          variant={"kioskPrimary"}
          onClick={onDone}
          data-testid={"done-button"}
        >
          <Trans i18nKey={"actions.done"}>Done</Trans>
        </Button>
      </MotionDiv>
    </Flex>
  );
};

export default Fantastic;
